import { HERO_STATS } from '../data/site';
import { useCountUp } from '../hooks/useCountUp';

function Stat({ stat, index }) {
  const { ref, value } = useCountUp(stat.v, 1400);
  return (
    <div
      ref={ref}
      className="reveal py-8 lg:py-10 pr-6 lg:px-8 first:lg:pl-0 border-b sm:border-b-0 sm:border-l border-line first:border-l-0 [&:nth-child(2)]:border-b sm:[&:nth-child(2)]:border-b-0"
      style={{ '--d': `${index * 90}ms` }}
    >
      <dt className="display text-4xl lg:text-5xl tabular-nums">
        {value}
        <span className="text-accent">{stat.suffix}</span>
      </dt>
      <dd className="mt-3 text-sm text-ink">{stat.l}</dd>
      <dd className="mt-1 font-mono text-[11px] text-faint">{stat.sub}</dd>
    </div>
  );
}

export default function Stats() {
  return (
    <dl
      className="mt-20 lg:mt-28 grid grid-cols-2 lg:grid-cols-4 border-y border-line"
      aria-label="Key metrics"
    >
      {HERO_STATS.map((s, i) => (
        <Stat key={s.l} stat={s} index={i} />
      ))}
    </dl>
  );
}
